import { render, staticRenderFns } from "./LgsIndex.vue?vue&type=template&id=e5ce7914&"
import script from "./LgsIndex.vue?vue&type=script&lang=js&"
export * from "./LgsIndex.vue?vue&type=script&lang=js&"
import style0 from "./LgsIndex.vue?vue&type=style&index=0&id=e5ce7914&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports